import { useAccount } from './ui/account-context';

export interface Message {
    type: 'user' | 'bot';
    text: string;
    timestamp: string;
}

export interface ChatSession {
    sessionId: string;
    agentId?: string; // Added agentId
    created: string;
    lastUpdated: string;
    summary: string;
    messages?: Message[];
}

export const useChatHistory = () => {
    const {
        currentSessionId,
        currentMessages,
        loadSession,
        startNewSession,
        conversations,
        refreshConversations,
        addMessage,
        deleteSession,
        deleteAllSessions
    } = useAccount();

    return {
        currentSessionId,
        currentMessages,
        addMessage,
        loadSession,
        startNewSession,
        getSessionHistories: () => conversations || [],
        refreshConversations,
        deleteSession,
        deleteAllSessions,
        // These can be implemented later if needed, but for now we'll stub them
        downloadHistory: () => { console.log('Download history not yet implemented with Firestore'); },
        importHistory: (file: File) => { console.log('Import history not yet implemented with Firestore', file); }
    };
};
